import { render, staticRenderFns } from "./DataCollectionReassignModal.vue?vue&type=template&id=6eb1fce0&"
import script from "./DataCollectionReassignModal.vue?vue&type=script&lang=js&"
export * from "./DataCollectionReassignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports